// src/components/site/FooterLegalNav.tsx
"use client";

import NavLink from "./NavLink";

export default function FooterLegalNav() {
  return (
    <nav className="flex flex-wrap items-center gap-x-4 gap-y-2" aria-label="Site">
      <NavLink href="/help">Help</NavLink>
      {/* Public status is the Better Stack page, never /health (Phase 15a). */}
      <a
        href="https://status.scholar-sidekick.com"
        target="_blank"
        rel="noopener"
        className="text-sm font-medium hover:underline underline-offset-4"
      >
        Status
      </a>
      <NavLink href="/about">About</NavLink>
      <NavLink href="/explainer">Explainer</NavLink>
      <NavLink href="/glossary">Glossary</NavLink>
      <NavLink href="/compare">Compare</NavLink>
      <NavLink href="/developers">Developers</NavLink>
      <NavLink href="/accessibility">Accessibility</NavLink>
      <NavLink href="/engineering-principles">Engineering</NavLink>
      <NavLink href="/legal/privacy">Privacy</NavLink>
      <NavLink href="/legal/terms">Terms</NavLink>
      <NavLink href="/legal/api-terms">API Terms</NavLink>
    </nav>
  );
}
